import { render, staticRenderFns } from "./ApiAuthConfig.vue?vue&type=template&id=1b5c9010&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ApiAuthConfig.vue?vue&type=script&lang=js"
export * from "./ApiAuthConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5c9010')) {
      api.createRecord('1b5c9010', component.options)
    } else {
      api.reload('1b5c9010', component.options)
    }
    module.hot.accept("./ApiAuthConfig.vue?vue&type=template&id=1b5c9010&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform", function () {
      api.rerender('1b5c9010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/ApiAuthConfig.vue"
export default component.exports